import React, { useState } from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Chip,
  FormControl,
  Select,
  MenuItem,
  Button,
} from '@mui/material';
import { Search, Clear, FilterList } from '@mui/icons-material';

const NewsSearch = ({ onSearch, onClear, category = 'all' }) => {
  const [query, setQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('all');

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch({ query: query.trim(), dateFilter, category });
    }
  };

  const handleClear = () => {
    setQuery('');
    setDateFilter('all');
    onClear();
  };



  return (
    <Box mb={3}>
      <Box component="form" onSubmit={handleSearch}>
        <TextField
          fullWidth
          placeholder="Search news articles..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: query && (
              <InputAdornment position="end">
                <IconButton size="small" onClick={handleClear} edge="end">
                  <Clear />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderRadius: 3,
              bgcolor: 'background.paper',
              '&:hover': {
                bgcolor: 'action.hover',
              },
              '&.Mui-focused': {
                bgcolor: 'background.paper',
              }
            }
          }}
        />
      </Box>

      {query && (
        <Box mt={2} display="flex" gap={1} alignItems="center" justifyContent="center">
          <Chip
            label={`Searching: "${query}"`}
            onDelete={handleClear}
            color="primary"
            size="small"
          />
          {dateFilter !== 'all' && (
            <Chip
              label={`Time: ${dateFilter}`}
              size="small"
              variant="outlined"
            />
          )}
        </Box>
      )}
      
      {/* <Box mt={2} display="flex" gap={2} alignItems="center" justifyContent="center">
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <Select
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <FilterList sx={{ fontSize: 20, ml: 1 }} />
              </InputAdornment>
            }
            sx={{
              borderRadius: 3,
              bgcolor: 'background.paper',
            }}
          >
            <MenuItem value="all">All Time</MenuItem>
            <MenuItem value="today">Today</MenuItem>
            <MenuItem value="week">This Week</MenuItem>
            <MenuItem value="month">This Month</MenuItem>
            <MenuItem value="year">This Year</MenuItem>
          </Select>
        </FormControl>
      </Box> */}
    </Box>
  );
};

export default NewsSearch;
